import React from 'react'
import { BrowserRouter, Routes, Route, Link} from 'react-router-dom'
import Home from './Pages/Home'
import About from './Pages/About'
import Course from './Pages/Course'
import Joinus from './Pages/Joinus'
import Vision from './Pages/Vision'
import Instructor from './Pages/ Instructor'
import Placement from './Pages/Placement'
import Freetraining from './Pages/Freetraining'
import Contact from './Pages/Contact'
import Corporate from './Pages/Corporate'
import Faqs from './Pages/Faqs'
import Democlass from './Pages/Democlass'
import Coursevideos from './Pages/Coursevideos'
import Registernow from './Pages/Registernow'
import Academic from './Pages/Academic'
import Coursedetail from './Pages/Coursedetail'
import Courseforfresher from './Pages/Courseforfresher'
import Courseforprof from './Pages/Courseforprof'
import Courseforonline from './Pages/Courseforonline'
import Privacy from './Pages/Privacy'
import Refund from './Pages/Refund'
import Termsncond from './Pages/Termsncond'
import Internship from './Pages/Internship'
import Physicaldesign from './Pages/Fresher/Physicaldesign'
import ASIC from './Pages/Fresher/ASIC'
import Analoglayout from './Pages/Fresher/Analoglayout'
import DFT from './Pages/Fresher/DFT'
import Analogcircuit from './Pages/Fresher/Analogcircuit'
import RTL from './Pages/Fresher/RTL'
import Embedded from './Pages/Fresher/Embedded'
import Physicalpt from './Pages/Professional/Physicalpt'
import Analoglayoutpt from './Pages/Professional/Analoglayoutpt'
import FINFET from './Pages/Professional/FINFET'
import UVM from './Pages/Professional/UVM'
import PERL from './Pages/Professional/PERL'
import ASICpt from './Pages/Professional/ASICpt'
import DFTpt from './Pages/Professional/DFTpt'
import RTLpt from './Pages/Professional/RTLpt'
import Physicalonline from './Pages/Online/Physicalonline'
import ASIConline from './Pages/Online/ASIConline'
import Analoglayoutonline from './Pages/Online/Analoglayoutonline'
import DFTonline from './Pages/Online/DFTonline'
import Analogclircuitonline from './Pages/Online/Analogclircuitonline'
import RTLonline from './Pages/Online/RTLonline'
import Coursecal from './Pages/Coursecal'
import UVMonline from './Pages/Online/UVMonline'
import Formpdf from './Components/Formpdf/Formpdf'
import Chaitanya from './Pages/Teachers/Chaitanya'
import Siva from './Pages/Teachers/Siva'
import Raja from './Pages/Teachers/Raja'
import Rajiv from './Pages/Teachers/Rajiv'
import Sateesh from './Pages/Teachers/Sateesh'
import Sadakshari from './Pages/Teachers/Sadakshari'
import Charan from './Pages/Teachers/Charan'
import Ram from './Pages/Teachers/Ram'
import Teachers from './Pages/Teachers'
import NotFound from "./NotFound";
import Bangalore from './Pages/Bangalore'
import Chennai from './Pages/Chennai'
import Hyderabad from './Pages/Hyderabad'


const App = () => {
  return (
    <main>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home/>}/>
          <Route path='/home' element={<Home/>}/>
          <Route path='/about-us' element={<About/>} exact/>
          <Route path='/courses' element={<Course/>}/>
            <Route path='/product-category/vlsi-courses-for-freshers/' element={<Courseforfresher/>}/>
              <Route path='/physical-design' element={<Physicaldesign/>}/>
              <Route path='/asic-verification/' element={<ASIC/>}/>
              <Route path='/analog-layout-design/' element={<Analoglayout/>}/>
              <Route path='/design-for-test/' element={<DFT/>}/>
              <Route path='/analog-circuit-design/' element={<Analogcircuit/>}/>
              <Route path='/rtl-coding-fpga-design/' element={<RTL/>}/>
              <Route path='/embedded-systems-training/' element={<Embedded/>}/>
            <Route path='/product-category/vlsi-courses-for-professionals/' element={<Courseforprof/>}/>
              <Route path='/physical-design-part-time/' element={<Physicalpt/>}/>
              <Route path='/asic-verification-part-time/' element={<ASICpt/>}/>
              <Route path='/analog-layout-design-part-time/' element={<Analoglayoutpt/>}/>
              <Route path='/design-for-test-part-time/' element={<DFTpt/>}/>
              <Route path='/rtl-coding-fpga-design-part-time/' element={<RTLpt/>}/>
              <Route path='/analog-circuit-design/' element={<Analogcircuit/>}/>
              <Route path='/finfet-layout-design/' element={<FINFET/>}/>
              <Route path='/uvm-training/' element={<UVM/>}/>
              <Route path='/perl-scripting/' element={<PERL/>}/>
            <Route path='/product-category/vlsi-online-courses/' element={<Courseforonline/>}/>
              <Route path='/physical-design-online/' element={<Physicalonline/>}/>
              <Route path='/asic-verification-online/' element={<ASIConline/>}/>
              <Route path='/analog-layout-design-online/' element={<Analoglayoutonline/>}/>
              <Route path='/design-for-test-dft-online/' element={<DFTonline/>}/>
              <Route path='/analog-circuit-design-online/' element={<Analogclircuitonline/>}/>
              <Route path='/rtl-coding-and-fpga-design-online/' element={<RTLonline/>}/>
              <Route path='/uvm-training-online/' element={<UVMonline/>}/>
          <Route path='/course-calendar' element={<Coursecal/>}/>
          <Route path='/why-join-us' element={<Joinus/>}/>
          <Route path='/vision' element={<Vision/>}/>
          <Route path='/apply-trainer/' element={<Instructor/>}/>
          <Route path='/placements' element={<Placement/>}/>
          <Route path='/events/1-day-free-vlsi-training/' element={<Freetraining/>}/>
          <Route path='/contact-us/' element={<Contact/>}/>
          <Route path='/corporate-trainings/' element={<Corporate/>}/>
          <Route path='/academic/' element={<Academic/>}/>
          <Route path='/faq/' element={<Faqs/>}/>
          <Route path='/events/demo-class/' element={<Democlass/>}/>
          <Route path='/course-videos/' element={<Coursevideos/>}/>
          <Route path='/register-now/' element={<Registernow/>}/>
          <Route path='/privacy-policy/' element={<Privacy/>}/>
          <Route path='/refund-policy/' element={<Refund/>}/>
          <Route path='/terms-and-conditions/' element={<Termsncond/>}/>
          <Route path='/vlsi-internship/' element={<Internship/>}/>
          <Route path='/form/' element={<Formpdf/>}/>
          <Route path='/teachers/' element={<Teachers/>}/>
          <Route path='/teachers/chaitanya/' element={<Chaitanya/>}/>
          <Route path='/teachers/siva/' element={<Siva/>}/>
          <Route path='/teachers/raja/' element={<Raja/>}/>
          <Route path='/teachers/rajiv/' element={<Rajiv/>}/>
          <Route path='/teachers/sateesh/' element={<Sateesh/>}/>
          <Route path='/teachers/sadakshari/' element={<Sadakshari/>}/>
          <Route path='/teachers/charan/' element={<Charan/>}/>
          <Route path='/teachers/ram/' element={<Ram/>}/>
          <Route path='/best-vlsi-institute-in-bengaluru/' element={<Bangalore/>}/>
          <Route path='/best-vlsi-institute-in-hyderabad/' element={<Hyderabad/>}/>
          <Route path='/best-vlsi-institute-in-chennai/' element={<Chennai/>}/>

          {/* Catch all undefined routes */}
        <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
          
    </main>
  )
}

export default App